import { Base, createApp } from '@studiometa/js-toolkit';
import {
  Frame,
  FrameTarget,
  FrameAnchor,
  Panel,
  ScrollAnimationParent,
  ScrollAnimationChild,
} from '@studiometa/ui';
import Card from './components/Card.js';
import CardCursor from './components/CardCursor.js';
import Deck from './components/Deck.js';
import Fade from './components/Fade.js';
import SignForm from './components/SignForm.js';
import WishcardPage from './components/WishcardPage.js';
import WishlistPage from './components/WishlistPage.js';
import TeamScrollParent from './components/TeamCardAnimation.js';
import WishlistCardAnimation from './components/WishlistCardAnimation.js';
import Select from './components/Select.js';
import AnimatedBlobs from './components/AnimatedBlobs.js';

/**
 * @typedef {{
 *   $children: {
 *     Frame: Frame[]
 *     Panel: Panel[]
 *     Card: Card[]
 *     Deck: Deck[]
 *     Fade: Fade[]
 *     SignForm: SignForm[]
 *     WishcardPage: WishcardPage[]
 *     WishlistPage: WishlistPage[]
 *     ScrollAnimationParent: ScrollAnimationParent[]
 *     ScrollAnimationChild: ScrollAnimationChild[]
 *     CardCursor: CardCursor[]
 *     AnimatedBlobs: AnimatedBlobs[]
 *   }
 * }} AppProps
 */

/**
 * App class.
 * @augments {Base<AppProps>}
 */
class App extends Base {
  /**
   * Config.
   * @type {import('@studiometa/js-toolkit').BaseConfig}
   */
  static config = {
    name: 'App',
    components: {
      Frame,
      FrameTarget,
      FrameAnchor,
      Panel,
      Card,
      Deck,
      Fade,
      CardCursor,
      SignForm,
      WishcardPage,
      WishlistPage,
      ScrollAnimationParent,
      ScrollAnimationChild,
      TeamScrollParent,
      WishlistCardAnimation,
      Select,
      AnimatedBlobs,
    },
  };
}

export default createApp(App);
